import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmModal = ({ isOpen, onClose, client, language, onConfirm }) => {
  if (!isOpen || !client) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm">
      <div className="bg-card border border-border rounded-lg shadow-elevation-lg w-full max-w-md">
        <div className="flex items-center gap-3 px-6 py-4 border-b border-border">
          <div className="w-10 h-10 rounded-full bg-error/10 text-error flex items-center justify-center">
            <Icon name="AlertTriangle" size={20} />
          </div>
          <h2 className="text-lg md:text-xl font-semibold text-foreground">
            {language === 'ar' ? 'تأكيد الحذف' : language === 'fr' ? 'Confirmer la suppression' : 'Confirm Delete'}
          </h2>
        </div>

        <div className="px-6 py-4">
          <p className="text-foreground mb-2">
            {language === 'ar' ?'هل أنت متأكد أنك تريد حذف هذا العميل؟'
              : language === 'fr' ?'Êtes-vous sûr de vouloir supprimer ce client?' :'Are you sure you want to delete this client?'}
          </p>
          <p className="text-sm text-muted-foreground">
            <strong>{client?.name}</strong> - {client?.clientId}
          </p>
          <p className="text-sm text-error mt-3">
            {language === 'ar' ?'لا يمكن التراجع عن هذا الإجراء.'
              : language === 'fr' ?'Cette action ne peut pas être annulée.' :'This action cannot be undone.'}
          </p>
        </div>

        <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-border bg-muted/30">
          <Button
            variant="outline"
            onClick={onClose}
          >
            {language === 'ar' ? 'إلغاء' : language === 'fr' ? 'Annuler' : 'Cancel'}
          </Button>
          <Button
            variant="destructive"
            onClick={() => {
              onConfirm(client);
              onClose();
            }}
            iconName="Trash2"
            iconPosition="left"
            iconSize={16}
          >
            {language === 'ar' ? 'حذف' : language === 'fr' ? 'Supprimer' : 'Delete'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;